var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('div', {
    directives: [{
      name: "padding",
      rawName: "v-padding",
      value: (3),
      expression: "3"
    }]
  }, [_c('v-text', {
    attrs: {
      "type": "headline"
    }
  }, [_vm._v("\n            Упс! Такой страницы нет\n        ")])], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b4274af","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/404.vue
// module id = 1144
// module chunks = 0